import{a as e}from"./chunk-RAAYCPUM.js";function a(...t){return e(o,t)}var o=(t,n)=>t===n||Object.is(t,n);export{a};
